import { useEffect, useState } from "react";

const today = () => new Date().toISOString().slice(0, 10);

async function api(path, options) {
  return fetch(path, { credentials: "same-origin", headers: { "Content-Type": "application/json" }, ...options });
}

const STATE_LABEL = { paid: "Paid", overdue: "Overdue", unpaid: "Not paid" };

export function MemberDues({ member, canManage }) {
  const [data, setData] = useState(null);
  const [form, setForm] = useState({ amount: "", paid_on: today(), method: "", note: "" });

  function load() {
    api(`/api/members/${member.id}/dues`)
      .then((res) => (res.ok ? res.json() : null))
      .then(setData);
  }
  useEffect(load, [member.id]);

  async function record(e) {
    e.preventDefault();
    await api(`/api/members/${member.id}/dues/payment`, { method: "POST", body: JSON.stringify(form) });
    setForm({ amount: "", paid_on: today(), method: "", note: "" });
    load();
  }
  async function removePayment(p) {
    await api(`/api/dues/payment/${p.id}`, { method: "DELETE" });
    load();
  }

  if (data === null) return <p className="muted">Loading dues…</p>;
  if (!data.enabled) {
    return <p className="muted">Dues tracking is off. Turn it on in Website → Pages → dues settings.</p>;
  }

  return (
    <div style={{ padding: "4px 2px" }}>
      <div style={{ marginBottom: 12 }}>
        <span className="pill" style={{ background: data.state === "paid" ? "var(--green-tint)" : "#fdeaea", color: data.state === "paid" ? "var(--green)" : "#b42318" }}>
          {STATE_LABEL[data.state]}
        </span>
        {data.paid_until && <span className="muted"> · paid until {data.paid_until}</span>}
        {data.amount && <span className="muted"> · {data.amount}</span>}
        <span className="muted"> · {data.cycle} cycle</span>
      </div>

      {data.payments.length ? (
        <table className="tbl" style={{ marginBottom: 12 }}>
          <thead><tr><th>Paid on</th><th>Amount</th><th>Covers until</th><th>Method</th>{canManage && <th />}</tr></thead>
          <tbody>
            {data.payments.map((p) => (
              <tr key={p.id}>
                <td>{p.paid_on}</td>
                <td>{p.amount ?? "—"}</td>
                <td className="muted">{p.covers_until || "—"}</td>
                <td className="muted">{p.method || "—"}</td>
                {canManage && <td className="row-actions"><button className="btn-danger" type="button" onClick={() => removePayment(p)}>Remove</button></td>}
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <p className="empty" style={{ marginBottom: 12 }}>No payments recorded.</p>
      )}

      {canManage && (
        <form className="field-actions" onSubmit={record} style={{ flexWrap: "wrap" }}>
          <input name="amount" placeholder="Amount" value={form.amount} onChange={(e) => setForm({ ...form, amount: e.target.value })} style={{ width: 100 }} />
          <input type="date" name="paid_on" value={form.paid_on} onChange={(e) => setForm({ ...form, paid_on: e.target.value })} style={{ width: "auto" }} />
          <input name="method" placeholder="Method" value={form.method} onChange={(e) => setForm({ ...form, method: e.target.value })} style={{ width: 120 }} />
          <button className="btn-primary" style={{ width: "auto" }} type="submit">Record payment</button>
        </form>
      )}
    </div>
  );
}
